import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash';
import * as analyticsMiddleware from '../../middleware/ga4-analytics';

import LoginForm from './LoginForm';

import './styles/Login.css';
import WMGLogo from '../../assets/images/WM_Logo.png';

export const USER_FIELD = 'username';
export const PASS_FIELD = 'password';
export const USER_REQUIRED = 'Username is required.';
export const PASS_REQUIRED = 'Password is required.';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    document.title = 'Login | CVM Insights';
  }

  // eslint-disable-next-line class-methods-use-this
  validate({ username, password }) {
    return {
      username: isEmpty(username) ? USER_REQUIRED : null,
      password: isEmpty(password) ? PASS_REQUIRED : null
    };
  }

  submit({ username, password }) {
    this.props.login(username, password);
  }

  renderForm() {
    const { contactEmail, errorMessage } = this.props;

    return (
      <section className="tvt-login">
        <div className="tvt-login__form-wrapper">
          <h1 className="tvt-login__header">Login</h1>
          {errorMessage && <h2 className="tvt-login__error">{errorMessage}</h2>}
          <LoginForm onSubmit={this.submit} validate={this.validate} />
        </div>

        <div className="tvt-login__help-msg">
          Need help? Contact{' '}
          <a
            className="tvt-login__help-msg-link"
            href={`mailto:${contactEmail}`}
          >
            {contactEmail}
          </a>
        </div>

        <div className="cvm-branding__logo">
          <img src={WMGLogo} alt="CVM Insights" />
        </div>
      </section>
    );
  }

  renderDowntimeMessage() {
    const titleMessage = 'The system is currently unavailable. ';
    const message =
      "We're very sorry for the inconvenience. Please try again later or contact your representative for support.";
    const { contactEmail } = this.props;

    return (
      <section className="tvt-login">
        <div className="tvt-login__form-wrapper">
          <h1 className="tvt-login__header">{titleMessage}</h1>
          <div>{message}</div>
        </div>

        <div className="tvt-login__help-msg">
          Need help? Send us a message at&nbsp;
          <a
            className="tvt-login__help-msg-link"
            href={`mailto:${contactEmail}`}
          >
            {contactEmail}
          </a>
        </div>
      </section>
    );
  }

  render() {
    let { firstAllowedPage } = this.props;
    const { loggedIn } = this.props;
    const redirectUponLogin = localStorage.getItem('requested_link_on_login');

    if (redirectUponLogin) {
      firstAllowedPage = redirectUponLogin;
    }

    if (loggedIn) {
      analyticsMiddleware.init();
      localStorage.removeItem('requested_link_on_login');
      return <Redirect to={!firstAllowedPage ? '/' : firstAllowedPage} />;
    }
    return this.renderForm();
  }
}

Login.propTypes = {
  contactEmail: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  firstAllowedPage: PropTypes.string,
  loggedIn: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired
  // hideForgotPassword: PropTypes.bool
};

Login.defaultProps = {
  errorMessage: null,
  firstAllowedPage: ''
  // hideForgotPassword: false
};

export default Login;
